// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"656":"profiler","952":"recorder"}[chunkId] + "." + {"656":"b1d3bb19","952":"14998e6f"}[chunkId] + ".chunk.js";
};